import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import EaPromotion from '@propertypal/shared/src/resources/icons/products/dev-social-media-icon.svg';
import Facebook from '@propertypal/shared/src/resources/icons/products/social-facebook.svg?url';
import Instagram from '@propertypal/shared/src/resources/icons/products/social-instagram.svg?url';
import PromoteSocialMediaMockup from '@propertypal/shared/src/resources/images/promotion-on-social-media/social-media-1.png';
import ProductsPageHeader, { ProcutsHeaderIcon } from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import { Box } from '@propertypal/web-ui/src/layout';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs from '@propertypal/web-ui/src/products/ProductScreenTabs';
import { FeaturesItem, FeaturesList } from '@propertypal/web-ui/src/products/ProductsFeatures.style';
import SocialKeyStatistics from '@propertypal/web-ui/src/products/SocialKeyStatistics';
import { LinkText, Text } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: "Promotion on PropertyPal's Social Media - PropertyPal",
  description: "Reach PropertyPal's Active Social Media Audience Across Multiple Platforms.",
  url: `/products/developers/promotion-on-social-media`,
};

const featureItems = [
  <>
    Tap into <b>300,000+</b> prospective buyers
  </>,
  `Enhance brand awareness of new homes`,
  `Drive more home seekers to a specific development`,
  `Utilise the PropertyPal distinct tone of voice`,
];

const icons: ProcutsHeaderIcon[] = [
  {
    src: Facebook.src,
    heading: 'Facebook Stories',
    text: `260,000+ Facebook Followers`,
    link: (
      <LinkText
        href="https://www.facebook.com/propertypal"
        target="_blank"
        rel="noreferrer"
        display="flex"
        alignItems="center"
        gap={5}
        mt={10}
      >
        <span>Follow us on Facebook</span>
        <FontAwesomeIcon icon={faChevronRight} size={14} />
      </LinkText>
    ),
    headingSize: 20,
    headingMt: 20,
    textSize: 16,
    textMt: 10,
    maxW: 220,
  },
  {
    src: Instagram.src,
    heading: 'Instagram Stories',
    text: `43,900+ Instagram Followers`,
    link: (
      <LinkText
        href="https://www.instagram.com/propertypal/"
        target="_blank"
        rel="noreferrer"
        display="flex"
        alignItems="center"
        gap={5}
        mt={10}
      >
        <span>Follow us on Instagram</span>
        <FontAwesomeIcon icon={faChevronRight} size={14} />
      </LinkText>
    ),
    headingSize: 20,
    headingMt: 20,
    textSize: 16,
    textMt: 10,
    maxW: 220,
  },
];

const PromotionOnSocialMedia = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Promotion on PropertyPal's Social Media"
        text="Reach PropertyPal's active social media audience across multiple platforms"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 770 }}
        icon={<EaPromotion />}
        icons={icons}
        iconsJustifyCenter
      />
      <ProductScreenTabs
        aspectRatio="136 / 125"
        mockupWidth={560}
        maxW={1100}
        tabPadding={100}
        breakpoint={1080}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        mockup={{
          src: PromoteSocialMediaMockup.src,
          alt: `Promotion on PropertyPal's Social Media`,
        }}
        content={
          <Box maxWidth={445}>
            <Text mb={20} lineHeight={25} align="left">
              With a monthly reach of over 5 million people, PropertyPal&apos;s Social platforms offer a fantastic
              targeting option for potential new leads.
            </Text>
            <Text mb={20} lineHeight={25} align="left">
              Promotion on PropertyPal&apos;s Social Media will link directly back to your listing on PropertyPal,
              ensuring that all those likes, clicks, comments and shares will help drive even more enquiries.
            </Text>
            <FeaturesList>
              {featureItems.map((f) => (
                <FeaturesItem key={f.toString()}>
                  <Text>{f}</Text>
                </FeaturesItem>
              ))}
            </FeaturesList>
          </Box>
        }
        staticTabs
        smallPrint="Statistics as of May 2024"
        smallPrintMt={65}
        pb={20}
      />
      <SocialKeyStatistics />
      <ProductsContact reason="Promotion on PropertyPal's Social Media" />
    </>
  );
};

export default PromotionOnSocialMedia;
